// // import City from '@/components/common/city/city.vue';
// // import chooseCity from '@/components/common/chooseCity/chooseCity.vue';
import fileUpload from '@/components/common/fileUpload/fileUpload.vue'
// // import fileImage from "@/components/common/fileImage/fileImage.vue";
// // import myViewer from "@/components/common/myViewer/myViewer.vue";
// // import mySelect from "@/components/common/mySelect/mySelect.vue";
import myInput from '@/components/common/myInput/myInput.vue'
// // import message from "@/components/common/message/message.vue";
// // import fileContainer from "@/components/common/fileContainer/fileContainer.vue";
// // import tianyancha from "@/components/common/tianyancha/tianyancha.vue";
// // import foldBlock from '@/components/common/foldBlock/foldBlock.vue';
import wpsFile from '@/components/common/wpsFile/wpsFile.vue'
// // import checkboxTable from "@/components/common/checkboxTable/index.vue";
// // import logisticsInformation from '@/components/common/logisticsInformation/index.vue';
// // import previewFile from '@/components/common/previewFile/previewFile.vue';
// // import countDown from "@/components/common/countDown/countDown.vue";
// // import codePay from "@/components/common/codePay/codePay.vue";
// // import infringementMap from "@/components/common/infringementMap/index.vue";

const views = {
//     City,
//     chooseCity,
  fileUpload,
  //     fileImage,
  //     myViewer,
  //     mySelect,
  myInput,
  //     message,
  //     fileContainer,
  //     tianyancha,
  //     foldBlock,
  wpsFile
//     checkboxTable,
//     logisticsInformation,
//     previewFile,
//     countDown,
//     codePay,
//     infringementMap
}

const install = function(Vue) {
  Object.keys(views).forEach((key) => {
    Vue.component(key, views[key])
  })
}

const API = {
  install
}

export default API



// WEBPACK FOOTER //
// ./src/components/common/index.js